export default "__VITE_ASSET__DZw$IICV__"